export default __webpack_public_path__ + "static/datova-analytica-da90fd597c38d643f5d7bcab891b0118.png";